/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){
    if(window.location.href.includes('reset_password')){
      $('#login').hide();
       $('.account__title').text('RESET PASSWORD');
      $('.heading-wrapper--account .heading-form').hide()
      $('#recover').show();
    }
    $('.js-recover-password').on('click', function(){
      $('#login').hide();
      $('#recover').show();
    });

    $('.cancel-recover-password').on('click', function(){
      $('#recover').hide();
      $('#login').show();
    })

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;